import { render, staticRenderFns } from "./DeleteGroupIconDialog.vue?vue&type=template&id=cf61388e&scoped=true"
import script from "./DeleteGroupIconDialog.vue?vue&type=script&lang=js"
export * from "./DeleteGroupIconDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf61388e",
  null
  
)

export default component.exports